const locale = () => (window.I18n && I18n.locale) || "fr"

export const t = (key, options) => I18n.t(`project_hours_board.${key}`, options)

export const fmtHours = (value, { zero = "0h" } = {}) => {
  const n = Number(value) || 0
  if (n === 0) return zero
  const sign    = n < 0 ? "-" : ""
  const total   = Math.round(Math.abs(n) * 60)
  const hours   = Math.floor(total / 60)
  const minutes = total % 60
  return `${sign}${hours}h${minutes ? String(minutes).padStart(2, "0") : ""}`
}

export const fmtMoney = value =>
  new Intl.NumberFormat(locale(), { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(value) || 0)

export const fmtNumber = value => new Intl.NumberFormat(locale()).format(Number(value) || 0)

export const fmtDistance = meters => {
  if (meters == null) return null
  const m = Number(meters)
  if (m < 1000) return `${Math.round(m)} m`
  return `${new Intl.NumberFormat(locale(), { maximumFractionDigits: 1 }).format(m / 1000)} km`
}

// A date-only ISO string read as a local calendar day (never shifted by the time zone).
export const parseDay = iso => {
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number)
  return new Date(y, m - 1, d)
}

export const fmtDay = (iso, options) => new Intl.DateTimeFormat(locale(), options).format(parseDay(iso))

export const weekdayShort = iso => fmtDay(iso, { weekday: "short" }).replace(".", "")
export const dayNumber    = iso => parseDay(iso).getDate()
export const fmtLongDay   = iso => fmtDay(iso, { weekday: "long", day: "numeric", month: "long" })

export const fmtPeriod = (from, to) => {
  const a = parseDay(from)
  const b = parseDay(to)
  const sameMonth = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()
  const left  = new Intl.DateTimeFormat(locale(), sameMonth ? { day: "numeric" } : { day: "numeric", month: "short" }).format(a)
  const right = new Intl.DateTimeFormat(locale(), { day: "numeric", month: "short", year: "numeric" }).format(b)
  return `${left} – ${right}`
}

export const fmtMonth = iso =>
  new Intl.DateTimeFormat(locale(), { month: "long", year: "numeric" }).format(parseDay(iso))

// A timestamp as written by the server (account time zone): "HH:MM" as is.
export const clock = iso => (iso ? String(iso).slice(11, 16) : "")

export const fmtStamp = iso => {
  if (!iso) return ""
  const date = new Date(iso)
  return new Intl.DateTimeFormat(locale(), { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }).format(date)
}

export const osmLink = (lat, lng) => `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`
